import React, { CSSProperties, PropsWithChildren } from 'react';
import { PreviewGridGapStyle } from './style';

interface PreviewGridProps {
  style?: CSSProperties;
  col: number;
  rowGap?: number;
  colGap?: number;
}

const PreviewGrid = (props: PropsWithChildren<PreviewGridProps>) => {
  const { children, style, col, rowGap = 0, colGap = 0 } = props;
  return (
    <PreviewGridGapStyle style={style} col={col} rowGap={rowGap} colGap={colGap}>
      {children}
    </PreviewGridGapStyle>
  );
};

export default PreviewGrid;
